import { SET_SELECTED_MARKER, REMOVE_SELECTED_MARKER } from "./mapview.types"

export const setSelectedMarker =(business)=>({
   type: SET_SELECTED_MARKER,
   payload: business
})
export const removeSelectedMarker =()=>({
  type: REMOVE_SELECTED_MARKER
})